import React from 'react'
import { IconS24InfoCircle24 } from '@is24/cosma-ui-icons'
import { PopoverBeta, PopoverContainer, PopoverTarget } from 'is24-corecss'
import styles from './LabelWithTooltip.module.css'

export interface LabelWithTooltipProps {
  inputId: string
  labelText: string
  tooltipContent: React.ReactNode
  showMandatory?: boolean
  arrowPosition?: 'left' | 'center' | 'right'
  bodyPosition?: 'top' | 'right' | 'bottom' | 'left'
  containerClassName?: string
  labelClassName?: string
}

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({
  inputId,
  labelText,
  tooltipContent,
  showMandatory = true,
  arrowPosition = 'left',
  containerClassName = '',
  labelClassName = '',
  bodyPosition = 'bottom',
}) => {
  const labelContent = (
    <label
      htmlFor={inputId}
      id={`${inputId}-input-label`}
      className={`input-label ${showMandatory ? ' mandatory ' : ''} ${labelClassName} ${styles.labelHeight}`}
    >
      {labelText}
    </label>
  )

  return (
    <div className={`display-inline-flex ${containerClassName}`} style={{ alignItems: 'center' }}>
      {labelContent}
      <PopoverContainer className='margin-left-s'>
        <PopoverTarget className='font-body-medium-regular align-left'>
          <IconS24InfoCircle24 style={{ color: '#757575' }} width={20} height={20} />
        </PopoverTarget>
        <PopoverBeta bodyPosition={bodyPosition} arrowPosition={arrowPosition} className={''}>
          {tooltipContent}
        </PopoverBeta>
      </PopoverContainer>
    </div>
  )
}

export default LabelWithTooltip
